import React from 'react';
import { getModuleCtxMiddleware, getModuleDucks } from '../modules/module-parsers.js';
import { getDuckEgg, wrapperInitializer } from '../redux/store.js';
import { enhanceNextCtx } from '../ctx-middleware/enhanceNextCtx.js';

const withBonnetPage = (PageComponent, options = {}) => {
  const {
    reducers = [],
    modules = []
  } = options;
  const hasModules = modules.length > 0;

  // Aggregate any ctx middleware supplied by modules
  const withModuleCtxMiddleware = getModuleCtxMiddleware(modules);

  // extract all the module ducks
  const moduleDucks = getModuleDucks(modules);

  // create a collection of all "duck" reducers
  const ducks = [...reducers, ...moduleDucks];

  // convert all "ducks" into @redux/eggs
  const duckEggs = ducks.map(getDuckEgg);

  // load duck eggs to the page and get enhancement wrappers
  const {
    wrapPage,
    wrapGetInitialProps,
    wrapGetServerSideProps,
    wrapGetStaticProps
  } = wrapperInitializer.getPageWrapper(duckEggs);

  // wrap the new page
  const BonnetPageComponent = wrapPage(props => /*#__PURE__*/React.createElement(PageComponent, props));
  const withEnhancedCtx = fn => store => async ctx => {
    await enhanceNextCtx(ctx, store);
    if (hasModules) {
      ctx.withModuleCtxMiddleware = withModuleCtxMiddleware;
    }
    return fn(ctx);
  };

  // pass displayName on to wrapped component for debugging
  // Give priority to displayName over name if it exists
  BonnetPageComponent.displayName = PageComponent.displayName || PageComponent.name;
  if (PageComponent.getInitialProps) {
    BonnetPageComponent.getInitialProps = wrapGetInitialProps(withEnhancedCtx(PageComponent.getInitialProps));
  }
  return {
    BonnetPageComponent,
    enhanceGetServerSideProps: fn => wrapGetServerSideProps(withEnhancedCtx(fn)),
    enhanceGetStaticProps: fn => wrapGetStaticProps(withEnhancedCtx(fn))
  };
};

export { withBonnetPage };
